import { useState, useEffect } from 'react';
import { eventScheduleService } from '@/features/events/services/eventScheduleService';
import type { Artist } from '@/features/clubs/types/types';

interface UseEventArtistsReturn {
    artists: Artist[];
    loading: boolean;
    error: string | null;
}

export const useEventArtists = (eventId: string | undefined): UseEventArtistsReturn => {
    const [artists, setArtists] = useState<Artist[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchArtists = async () => {
            if (!eventId) {
                setArtists([]);
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                setError(null);
                const artistsData = await eventScheduleService.getEventArtists(eventId);
                setArtists(artistsData);
            } catch (err) {
                console.error('Error fetching event artists:', err);
                setError('Failed to load artists');
                setArtists([]);
            } finally {
                setLoading(false);
            }
        };

        fetchArtists();
    }, [eventId]);

    return {
        artists,
        loading,
        error
    };
};
